import React, { useState, useEffect } from 'react';

import {
  useParams
} from "react-router-dom";

import { Tag } from "@blueprintjs/core";

import TemplateSelectorDialog from './message_template_dialog/message_template_dialog.js';

import userPlaceholder from "../../user-placeholder.png";

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
export default function Panel(props) {
  const [isSearching, setIsSearching] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [contacts, setContacts] = useState(props.directory)
  const [currentMembers, setCurrentMembers] = useState([])

  const [templateSelectorIsOpen, setTemplateSelectorIsOpen] = useState(false)
  const [templateSelectorBroadcastList, setTemplateSelectorBroadcastList] = useState(null)

  const { id } = useParams();

  const closeTemplateSelectorDialog = () => {
    setTemplateSelectorIsOpen(false)
    setTemplateSelectorBroadcastList(null)
    close()
  }

  const openTemplateSelectorDialog = () => {
    setTemplateSelectorIsOpen(true)
    setTemplateSelectorBroadcastList(id)
  }

  const loadBroadcastList = () => {
    props.loadBroadcastListMembers(props.currentAgent.usuario.emailreal, { id: id }).then(members => {
      const newState = contacts.map(c => {
        if(members.find(m => m.numeroCliente.replace(/"/g, '') === c.numeroCliente)) {
          c.tagged = true;
        }
        return c
      })

      setContacts(newState)
      setCurrentMembers(members)
    })
  }

  useEffect(loadBroadcastList, [id]);

  const partition = (col, predicate) => {
    const left = [], right = []

    col.forEach(it => {
      if(predicate(it)) {
        left.push(it)
      } else {
        right.push(it)
      }
    })

    return [left, right]
  }

  const [directoryList, groupMembers] = partition(contacts, x => !x.tagged)

  const style = {
    left: props.isOpen ? "0" : "-110%",
  };

  const renderContact = (c) => {
    return (
      <li className="media my-1 contact p-2" key={c.numeroCliente} onClick={handleClickContact.bind(this, c, true)}>
        <img src={userPlaceholder} width="50" height="50" className="mr-3 rounded-circle" alt="..."/>
        <div className="media-body py-1">
          <h5 className="mt-0 mb-1">{c.nombreCompleto}</h5>
          <div>No. Cliente: {c.numeroCliente}</div>
          <small>Cel: {c.telefonoCelular} &mdash; Email: {c.email}</small>
        </div>
      </li>
    )
  }

  const renderEntry = (letter) => {
    return (
      <li className="media p-2" key={letter}>
        <h1>{letter}</h1>
      </li>
    )
  }

  const handleClickContact = (contact, param) => {
    const newState = contacts.map(c => {
        if(c.numeroCliente === contact.numeroCliente) {
          c.tagged = param;
        }
        return c
      }
    )

    setContacts(newState)
  }

  const handleSearch = (e) => {
    const query = e.target.value.toUpperCase()
    setSearchQuery(query)
    setIsSearching(query.length > 0)
  }

  const handleCreation = (e) => {
    const toBeAdded = groupMembers.filter(g => !currentMembers.find(c => c.numeroCliente.replace(/"/g, '') === g.numeroCliente))
    const toBeRemoved = currentMembers.filter(c => !groupMembers.find(g => c.numeroCliente.replace(/"/g, '') === g.numeroCliente))


    if(toBeAdded.length > 0) {
      const members = toBeAdded.map(x => ({ clientNumber: x.numeroCliente, phoneNumber: x.telefonoCelular }) )
      props.appendBroadcastListMembers(props.currentAgent.usuario.emailreal, { id: id }, members)
    }

    if(toBeRemoved.length > 0) {
      const tasks = toBeRemoved.map(m => props.removeBroadcastListMember(props.currentAgent.usuario.emailreal, {id: id}, m.numeroCliente.replace(/"/g, '')))
      Promise.all(tasks)
    }
    close()
  }

  const handleRemove = (e) => {
    if(window.confirm("¿Estás seguro de eliminar esta difusión?")) {
      props.removeBroadcastList(props.currentAgent.usuario.emailreal, { id: id })
        .finally(() => close())
    }
  }

  const close = () => {
    props.close()
    props.loadBroadcastLists(props.currentAgent.usuario.emailreal)
    const newState = contacts.map(c => {
      c.tagged = false;
      return c
    })

    setContacts(newState)
  }

  const sortedContacts = directoryList.sort((a, b) => a.nombreCompleto > b.nombreCompleto ? 1 : -1);
  let entry = '';

  const toRender = sortedContacts.flatMap(contact => {
    if(isSearching) {
      if(contact.nombreCompleto.toUpperCase().includes(searchQuery) ||
        contact.telefonoCelular.toUpperCase().includes(searchQuery) ||
        contact.email.toUpperCase().includes(searchQuery)) {
        return [renderContact(contact)]
      }
    } else  {
      const firstLetter = contact.nombreCompleto[0]
      if (firstLetter !== entry) {
        entry = firstLetter
        return [renderEntry(firstLetter), renderContact(contact)]
      } else {
        return [renderContact(contact)]
      }
    }
  })

  const renderTags =
    groupMembers.map(member =>
      <Tag
          key={member.numeroCliente}
          onRemove={handleClickContact.bind(this, member, false)}
          icon={<img src="https://via.placeholder.com/25" className="mr-3 rounded-circle" alt="..."/>}
          round={true}>{member.nombreCompleto}
      </Tag>
    )

  return (
    <div className="d-flex flex-column w-100 h-100 left-panel" id="new-group" style={style}>
      <div className="row d-flex flex-row align-items-center p-2 m-0" style={{backgroundColor:"white", minHeight:"65px"}}>
          <i className="fas fa-arrow-left p-2 mx-3 my-1" style={{fontSize: "1.5rem", cursor: "pointer"}} onClick={close}></i>
          <div className="font-weight-bold">Info. de difusión</div>
          <div className="nav-item ml-auto px-2">
            <button className="btn nav-link" onClick={openTemplateSelectorDialog}><i className="fas fa-paper-plane fa-lg"></i></button>
          </div>
      </div>
      <div className="d-flex flex-column bg-white" style={{overflow:"auto"}}>
        <div className="px-3 py-2">
          {renderTags}
        </div>
        <div className="px-3 py-2">
          <div className="input-group mb-3">
            <input
              type="text"
              className="input-wa"
              placeholder="Buscar contactos"
              onChange={handleSearch}/>
          </div>
        </div>
        <ul className="list-unstyled bg-white">
          {toRender}
        </ul>
      </div>
      <div className="row d-flex flex-row align-items-center p-2 m-0 justify-content-center">
        <button
          onClick={handleRemove.bind(this)}
          disabled={groupMembers.length < 1}
          type="submit"
          style={{borderRadius:"25px"}}
          className="btn btn-danger btn-icon">
          <i className="fa fa-trash"></i> Eliminar difusión
        </button>
      </div>
      <div className="row d-flex flex-row align-items-center p-2 m-0 justify-content-center" style={{background:"rgba(219,219,219, 0.5)", minHeight:"65px"}}>
        <button
          disabled={groupMembers.length < 1}
          type="submit"
          style={{borderRadius:"25px"}}
          className="btn btn-success btn-icon"
          onClick={handleCreation.bind(this)}>
          <i className="fa fa-arrow-right"></i>
        </button>
      </div>
      <TemplateSelectorDialog
        isOpen={templateSelectorIsOpen}
        close={closeTemplateSelectorDialog}
        templateList={props.templateList}
        currentAgent={props.currentAgent}
        defaultValue={templateSelectorBroadcastList}
      />
    </div>
  )
}
